// Boilerplate for the quote builder: the event packages and the one-tap note
// blocks. Package prices live in the Services catalog (More → Services) so they
// can change without a code edit; these are only the fallback if it can't load.

export const FALLBACK_PACKAGES = [
  { id: "pkg-4h", name: "4-Hour Event", duration_minutes: 240, price_cents: 180000 },
  { id: "pkg-8h", name: "8-Hour Event", duration_minutes: 480, price_cents: 300000 },
];

/** Packages from the services catalog, else the built-in two. */
export function packagesFrom(services) {
  const fromCatalog = (services || [])
    .filter((s) => s.service_type === "package" && s.is_active !== false)
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.duration_minutes - b.duration_minutes);
  return fromCatalog.length ? fromCatalog : FALLBACK_PACKAGES;
}

/** The line item a package puts on the quote. */
export function packageLineDescription(pkg) {
  return `${pkg.name} — Birdie Bus mobile golf simulator`;
}

export const NOTE_BLOCKS = [
  {
    key: "included",
    label: "What's included",
    text: [
      "WHAT'S INCLUDED",
      "• The Birdie Bus mobile golf simulator for your booked hours",
      "• A Birdie Bus attendant on site the whole time",
      "• Clubs for everyone: men's righty and lefty, women's righty, and a junior set",
      "• Famous courses plus party games, with a competition we run for your guests (happy to coordinate a prize if you'd like to provide one)",
      "• Full setup and pack-down, so there's nothing for you to do",
    ].join("\n"),
  },
  {
    key: "space",
    label: "Space & power",
    text: [
      "SPACE & POWER",
      "• A flat, level area about 40 ft × 25 ft for the bus",
      "• No power needed. The bus runs on its own generator",
    ].join("\n"),
  },
  {
    key: "arrival",
    label: "Arrival & setup",
    text: [
      "ARRIVAL & SETUP",
      "• We arrive at least 60 minutes before your start time, sometimes earlier, to set up. We'll confirm the exact arrival time with you",
      "• Your hours start at your booked start time",
    ].join("\n"),
  },
];

const heading = (block) => block.text.split("\n")[0];

export function hasNoteBlock(notes, block) {
  return (notes || "").includes(heading(block));
}

/** Notes with the block appended (blank line between blocks), once. */
export function addNoteBlock(notes, block) {
  if (hasNoteBlock(notes, block)) return notes;
  const current = (notes || "").trimEnd();
  return current ? `${current}\n\n${block.text}` : block.text;
}
